module.exports = __webpack_public_path__ + "images/_/assets/images/download-dark.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-dark.png
// module id = ./src/assets/images/download-dark.png
// module chunks = 1